// extracted by mini-css-extract-plugin
export default {"p":"ef15528613 _461273d1aa _253f51bff2","clr":"_867ade46ad","dls":"_4787a87c17"};